import React from "react";
import { cn } from "../../lib/cn";

/**
 * Minimal section label (sentence case, light — avoids heavy “pill badge” blocks).
 * @param {"default" | "compact"} variant
 */
export function Eyebrow({
  children,
  variant = "default",
  className,
  tone = "light",
}) {
  const light = tone === "light";

  return (
    <div
      className={cn(
        "inline-flex items-center gap-2 font-medium tracking-normal",
        light ? "text-slate-500" : "text-slate-400",
        variant === "compact" ? "text-[11px] sm:text-xs" : "text-xs sm:text-[13px]",
        className,
      )}
    >
      <span
        className={cn(
          "h-1 w-1 shrink-0 rounded-full",
          light ? "bg-teal-600" : "bg-teal-500/80",
        )}
        aria-hidden
      />
      <span className={light ? "text-slate-600" : "text-slate-300"}>
        {children}
      </span>
    </div>
  );
}
